/* global fetch */

import React, { Component } from 'react';
import { Link } from 'react-router';
import { find } from 'lodash';
import lang, { selectedLocalization } from '../services/lang';
import Icon from '../components/Icon';
import './survey.css';

import { API_URI } from '../services/config';
import { surveys, questions } from '../services/content';
import { beep } from '../services/audio';
import { trackView } from '../services/analytics';

export default class Survey extends Component {
  
  constructor(props) {
    super();
    
    const survey = find(surveys, s => s._id === props.params.id) || surveys[0];
    
    const text = survey['text_'+selectedLocalization] || survey.text;
    
    let surveyQuestions = questions
      .filter(q => q.survey === survey._id)
      .map(question => {
        return {
          kind: question.kind,
          title: question['question_'+selectedLocalization] || question.question,
          // eslint-disable-next-line
          options: eval( question['choices_'+selectedLocalization] || question.choices ) || [],
        };
      });
    
    
    this.state = {
      survey,
      text,
      questionIndex: 0,
      questions: surveyQuestions,
      answers: {},
      isDone: false,
      isSubmitted: false,
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
    };

    trackView("Survey");
  }
  
  componentWillMount() {
    beep();
  }
  
  setAnswer(value) {
    const answers = this.state.answers;
    answers[this.state.questionIndex] = value;
    this.setState({answers});
  }
  
  submit() {
    const answers = [];
    for(let i in this.state.answers) {
      answers.push(this.state.answers[i]);
    }
    
    
    fetch(`${API_URI}/surveyresponse`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=UTF-8"
      },
      body: JSON.stringify({
        answers,
        email: this.state.email,
        first_name: this.state.firstName,
        last_name: this.state.lastName,
        language: selectedLocalization,
        phone: this.state.phone,
        survey: this.state.survey._id,
      })
    });
    
    beep();
    this.setState({isSubmitted:true});
  }
  
  next() {
    beep();
    let { questionIndex } = this.state;
    questionIndex += 1;
    
    if(questionIndex === this.state.questions.length) {
      this.setState({isDone:true});
      return;
    }
    
    this.setState({questionIndex});
  }
  
  renderOption(option, i) {
    const isSelected = this.state.answers[this.state.questionIndex] === option;
    return (
      <div 
        className={`survey-option ${isSelected ? 'is-selected' : ''}`}
        key={option}
        onClick={() => this.setAnswer(option)}>
        {option}
      </div>
    );
  }
  
  renderQuestion() {
    const question = this.state.questions[this.state.questionIndex];
    const answer = this.state.answers[this.state.questionIndex];
    
    return (
      <div>
        {this.renderTitle()}
        <div className="survey-question">
          <h3 className="survey-question-title">{question.title}</h3>
          <div className="survey-options">
            {question.kind === 'radio' && question.options.map(this.renderOption.bind(this))}
            {question.kind === 'text' && 
              <textarea 
                className="survey-textarea"
                value={answer}
                onChange={e => this.setAnswer(e.target.value)}>
              </textarea>
            }
          </div>
          <div className="survey-nav">
            <div
              onClick={this.next.bind(this)}
              className="survey-nav-button">
              <Icon name="next" className="survey-nav-button-icon"/>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  renderContact() {
    const { firstName, lastName, email, phone } = this.state;
    
    return (
      <div>
        {this.renderTitle()}
        <div className="survey-form">
          <input 
            type="text" 
            className="survey-field"
            placeholder={lang('first-name')} 
            value={firstName}
            onChange={e => this.setState({firstName:e.target.value})}
          />
          <input 
            type="text" 
            className="survey-field"
            placeholder={lang('last-name')} 
            value={lastName}
            onChange={e => this.setState({lastName:e.target.value})}
          />
          <input 
            type="text" 
            className="survey-field"
            placeholder={lang('email')} 
            value={email}
            onChange={e => this.setState({email:e.target.value})}
          />
          <input 
            type="text" 
            className="survey-field"
            placeholder={lang('phone')} 
            value={phone}
            onChange={e => this.setState({phone:e.target.value})}
          />
        </div>
        <div className="survey-nav">
          <div
            onClick={this.submit.bind(this)}
            className="survey-nav-button">
            {lang('submit-survey')}
          </div>
        </div>
      </div>
    );
  }
  
  renderThanks() {
    return (
      <h1>{lang('survey-thanks-page-title')}</h1>
    );  
  }
  
  renderTitle() {
    return <div dangerouslySetInnerHTML={{__html:this.state.text}}/>
  }
  
  renderSidebar() {
    return (
      <aside className="survey-sidebar">
        <h5 className="survey-sidebar-title">{lang('contact-page-sidebar-title')}</h5>
        <a href="tel:6504987061" className="survey-sidebar-link">
          <Icon name="phone" className="survey-sidebar-link-icon"/> 650.498.7061
        </a>
        <a href="mailto:ccto-office@stanford.edu" className="survey-sidebar-link">
          <Icon name="mail" className="survey-sidebar-link-icon"/> ccto-office@stanford.edu
        </a>
      </aside>
    );
  }
  
  renderFooter() {
    return (
      <div className="survey-menu-row">
        <div className="survey-menu">
          <h5 className="survey-menu-subtitle">{lang('survey')}</h5>
          <Link to="/menu" className="survey-menu-main">
            {lang('main-menu')} <Icon name="menuWhite" className="survey-menu-main-icon"/>
          </Link>
        </div>
      </div>
    );
  }
  
  render() {
    
    const { isDone, isSubmitted } = this.state;
    
    return (
      <div className="survey">
        
        <div className="survey-content-row">
        
          <article className="survey-content">
            {!isDone 
              ? this.renderQuestion() 
              : isSubmitted 
                ? this.renderThanks()
                : this.renderContact()
            }
          </article>
          
          {this.renderSidebar()}
          
        </div>
        
        {this.renderFooter()}
        
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Survey.js